function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { buildClassNames } from '../../modules/css-helpers';
import { createOwnUpComponent } from '../components';
import { OwnUpButtonStyle } from './button-style';
/**
 * Button component properties.
 */

var StyledComponent = createOwnUpComponent('button', OwnUpButtonStyle);
/**
 * An Own Up branded button. Changes color and size depending on
 *   variants and screen size.
 *
 * @param props see {@link OwnUpButtonProps}
 *   Note that `type` will default to "button"
 */

export var OwnUpButton = function OwnUpButton(_ref) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      props = _objectWithoutProperties(_ref, ["className", "type"]);

  var classes = buildClassNames('ou-button', className);
  return /*#__PURE__*/React.createElement(StyledComponent, _extends({
    type: type,
    className: classes
  }, props));
};